var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 24,
    viewBox: "0 0 104 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 13.0607C103.646 12.4749 103.646 11.5251 103.061 10.9393L93.5147 1.3934C92.9289 0.807611 91.9792 0.807611 91.3934 1.3934C90.8076 1.97919 90.8076 2.92893 91.3934 3.51472L99.8787 12L91.3934 20.4853C90.8076 21.0711 90.8076 22.0208 91.3934 22.6066C91.9792 23.1924 92.9289 23.1924 93.5147 22.6066L103.061 13.0607ZM0 13.5H102V10.5H0V13.5Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cc81426ec09728dd1f66e33b0ba0059d.svg";
export { ForwardRef as ReactComponent };